import { apiClient } from '../utils/api';

export async function getFormByFormId(id, appointmentChannelId = null) {
    return await apiClient.GET(`api/channels/widget/${id}${appointmentChannelId ? '?appointment_channel_id=' + appointmentChannelId : ''}`);
}
